{
    "name": "06 Star Booster",
    "title": "CountdownStarBonus",
    "description": "AddBonusCountdownPerkDescription1",
    "stat": 72,
    "lockFlag": 22
}
